import { IAIVideoModel } from 'types/aiVideo'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'

export const getCapabilityLabels = (models: IAIVideoModel[]): string[] => {
  const hasAudio = models.some(m => m.capabilities.isAudioGenerationSupported)
  return hasAudio ? [translate(T.AUDIO_LABEL)] : []
}
